export const setGarage = garage => localStorage.setItem('garage', JSON.stringify(garage))
export const getGarage = () => JSON.parse(localStorage.getItem('garage') || "[]")
export const deleteGarage = () => localStorage.removeItem('garage')


export const setCredito = credito => localStorage.setItem('credito', credito)
export const setDataAtualizacaoCredito = data => localStorage.setItem('data_atualizao_credito', data)
export const getDataAtualizacaoCredito =  () => localStorage.getItem('data_atualizao_credito') 
export const getCredito = () => localStorage.getItem('credito')
export const deleteCredito = () => localStorage.removeItem('credito')
export const deleteDataAtualizacaoCredito = () => localStorage.removeItem('data_atualizao_credito')


export const setGarageSelected = garage => localStorage.setItem('garage_selected', garage)
export const getGarageSelected = () => localStorage.getItem('garage_selected')
export const deleteGarageSelected = () => localStorage.removeItem('garage_selected')

export const setCarSelected = car => localStorage.setItem('car_selected', car)
export const getCarSelected = () => localStorage.getItem('car_selected')
export const deleteCarSelected = () => localStorage.removeItem('car_selected')